import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { ReactWrapperComponent } from '../react-wrapper/react-wrapper.component';
import { MatIcon } from '@angular/material/icon';
import { SelfLoadingDocumentDialogContent } from './DocumentDialog';
import { MatIconButton } from '@angular/material/button';

interface DialogData {
  documentId: string;
  companyId: string;
}

@Component({
  templateUrl: './document-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogClose, MatIcon, MatIconButton, ReactWrapperComponent],
})
export class DocumentDialogComponent {
  DocumentDialogContent = SelfLoadingDocumentDialogContent;

  documentId = this.data.documentId;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  static open(dialog: MatDialog, data: DialogData): MatDialogRef<DocumentDialogComponent, void> {
    return dialog.open(DocumentDialogComponent, {
      maxWidth: '90%',
      width: '90%',
      minHeight: '400px',
      disableClose: true,
      data,
    });
  }
}
